<script>
import UploadImage from "@/components/Form/FormUploadImage/UploadImage.vue";
import TakePhoto from "@/components/Form/FormUploadImage/TakePhoto.vue";

export default {
  components: {
    UploadImage,
    TakePhoto,
  },
  props: {
    value: [String, File, FileList],
    disabled: Boolean,
  },
  data() {
    return {
      mode: "upload-image",
      isMobile: false,
    };
  },
  computed: {
    component() {
      // return this.mode === "upload-image" ? "UploadImage" : "TakePhoto";
      if (this.isMobile) {
        return "UploadImage";
      }

      return this.mode === "upload-image" ? "UploadImage" : "TakePhoto";
    },
  },
  mounted() {
    this.checkDeviceType();
  },
  methods: {
    checkDeviceType() {
      const userAgent = navigator.userAgent;
      this.isMobile =
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          userAgent
        );
    },
  },
};
</script>

<template>
  <component
    :is="component"
    :value="value"
    :disabled="disabled"
    :is-mobile="isMobile"
    @input="$emit('input', $event)"
    @change="$emit('change', $event)"
    @on:mode="mode = $event"
  ></component>
</template>
